/**
 * Zelle payee extraction for rule matching (client-side mirror of src/utils/zellePayee.js).
 */

export function normalizePayeeName(s) {
  if (!s) return '';
  return s.toString().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
}

export function extractZellePayeeKey(description) {
  const normalized = normalizePayeeName(description);
  if (!normalized.includes('zelle')) return normalized;

  const afterZelle = normalized.match(/zelle\s+(.+)$/);
  if (!afterZelle) return normalized;

  let payee = afterZelle[1]
    .replace(/\s+\d{8,12}\s*$/, '')
    .replace(/\s+\d{8,12}\s+/g, ' ')
    .trim();

  payee = payee.replace(/^(debit|credit)\s+/, '').trim();
  return payee || normalized;
}

export function zellePayeeKeysMatch(ruleKey, txDescription) {
  const txPayee = extractZellePayeeKey(txDescription);
  const rulePayee = extractZellePayeeKey(ruleKey);

  if (!txPayee || !rulePayee) return false;
  if (txPayee === rulePayee) return true;

  // Same person, minor spelling drift — compare payee tokens only (never full bank line text)
  const txTokens = txPayee.split(' ').filter(Boolean);
  const ruleTokens = rulePayee.split(' ').filter(Boolean);
  if (txTokens.length >= 2 && ruleTokens.length >= 2) {
    const ruleLast = ruleTokens[ruleTokens.length - 1];
    const txLast = txTokens[txTokens.length - 1];
    const ruleFirst = ruleTokens[0];
    const txFirst = txTokens[0];
    if (ruleLast.length >= 3 && txLast === ruleLast && ruleFirst.length >= 2 && txFirst === ruleFirst) {
      return true;
    }
  }

  return false;
}

export function isZelleDescription(description) {
  return normalizePayeeName(description).includes('zelle');
}

export function ruleKeyForDescription(description) {
  if (isZelleDescription(description)) return extractZellePayeeKey(description);
  return normalizePayeeName(description);
}
